// extracted by mini-css-extract-plugin
export var container = "_7w-0";
export var error = "_7w-9";
export var label = "_7w-5";
export var light = "_7w-6";
export var md = "_7w-3";
export var sm = "_7w-2";
export var thin = "_7w-8";
export var thinBold = "_7w-7";
export var vertical = "_7w-4";
export var xs = "_7w-1";